export default __webpack_public_path__ + "static/media/tiktok-white.fc183f2c.svg";